export const prefixesPhone = ['+55', '+549'];
export const regexsPhone = [/^[0-9]{2}9[0-9]{8}$/, /^[0-9]{10}$/];
export const pixPhoneMask = ['00 0 0000-0000', '00 0000-0000'];
export const pixPhoneHint = ['xx 9 xxxx xxxx', 'xx xxxx xxxx'];

export function onAlphaInput(event: Event): string {
  const input = event.target as HTMLInputElement;

  let cleanValue = input.value
    .replace(/[^a-zA-Z\s]/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/g, '');
  input.value = cleanValue;

  return cleanValue;
}

export function onAlphaNumericInput(event: Event): string {
  const input = event.target as HTMLInputElement;
  let cleanValue = input.value
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^\s+/g, '');
  input.value = cleanValue;

  return cleanValue;
}

export function onNumberInput(event: Event): string {
  const input = event.target as HTMLInputElement;
  const numericValue = input.value.replace(/[^0-9]/g, '');

  return numericValue;
}
